angular.module('SpidApp')

.constant('DestinationZoneAdapterConfig', {
  name : 'DestinationZone',
  fields : [
    {
    	local   : 'code_destination',
    	distant : 'code_destination'
    }, {
    	local   : 'id_zone',
    	distant : 'id_zone'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }, {
    	local   : 'deleted_at',
    	distant : 'deleted_at'
    }
  ]
})
